<ng-container *ngIf="activeColumnsNames$ | async as activeColumnsNames">
  <td
    *ngIf="title !== 'subid' && title !== 'ivr' && title !== 'PPI'"
    class="option main"
    [ngClass]="{'campaign' : title !== 'stats_daily' && title !== 'countries' && title !== 'smartlinks_stats' && title !== 'incent_campaigns_stats'}">
    <ng-container *ngIf="campaign?.program_name">
      <div class="campaign-img" *ngIf="isDetailsTableLayout && campaign?.program_logo">
        <img src="{{ campaign?.program_logo }}" alt="{{ campaign?.program_name }}" />
      </div>
      <span
        ngbTooltip="{{ campaign?.program_name + (campaign?.program_id && !campaign?.program_name?.includes(campaign?.program_id?.toString() || '') ? ' (' + campaign?.program_id + ')' : '')}}"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"
        class="name">
        {{ campaign?.program_name + (campaign?.program_id && !campaign?.program_name?.includes(campaign?.program_id?.toString() || '') ? ' (' +
        campaign?.program_id + ')' : '')}}
      </span>
      <div class="campaign-types-container" *ngIf="campaign?.types">
        <span *ngFor="let type of Object.values(campaign?.types ?? {})" class="type fontsize14 {{ 'types.' + type.id | translate }}">
          {{ 'types.' + type.id | translate }}
        </span>
      </div>
    </ng-container>
    <div class="name d-flex flex-column" *ngIf="campaign?.day">
      {{ campaign?.day }}
      <span *ngIf="compareMode && campaignToCompare && campaignToCompare.day" class="compare">{{ campaignToCompare.day }} </span>
    </div>
    <span class="name" *ngIf="title === 'ivr'">{{ campaign?.program_id }}</span>
    <span class="name" *ngIf="title === 'referrals'">{{ campaign?.username}} ({{campaign?.id}})</span>
    <div *ngIf="checkIfColumnActive('username', activeColumnsNames)">
      <div class="campaign-img" *ngIf="isDetailsTableLayout">
        <img src="{{ campaign?.avatar }}" alt="user avatar" />
      </div>
      <span class="name">{{ campaign?.username }}</span>
    </div>
    <div class="flag-icon" *ngIf="campaign?.country && title === 'countries'">
      <div
        class="tooltip-button tool-tip"
        ngbTooltip="{{ ( 'countries.' + ( campaign?.country.id - 1 ) | translate).name }}"
        container="body"
        placement="right"
        tooltipClass="my-configurations-tooltip">
        <img class="flag-icon" src="{{ 'assets/icons/flags/' + campaign?.country.code.toLowerCase() + '.png' }}" alt="{{ campaign?.country.name }}" />
      </div>
    </div>
  </td>
  <!-- admin program for smartlinks and incent campaigns -->
  <td *ngIf="title === 'incent_campaigns_stats' || title === 'smartlinks_stats'" class="option admin-campaign">
    <ng-container *ngIf="campaign?.admin_program_name">
      <span
        ngbTooltip="{{ campaign?.admin_program_name + (campaign?.admin_program_id ? ' (' + campaign?.admin_program_id + ')' : '')}}"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"
        class="name"
        >{{ campaign?.admin_program_name + (campaign?.admin_program_id ? ' (' + campaign?.admin_program_id + ')' : '') }}</span
      >
    </ng-container>
  </td>
  <!-- admin program END -->

  <!-- configuration -->
  <td class="option" *ngIf="checkIfColumnActive('configurationName', activeColumnsNames)">
    <span>{{ campaign?.config_name }} ({{ campaign?.config_id }})</span>
  </td>
  <!-- configuration END -->

  <td class="option" *ngIf="checkIfColumnActive('leadID', activeColumnsNames) || checkIfColumnActive('visitID', activeColumnsNames)">
    <span>{{ campaign?.id }}</span>
  </td>
  <td class="option transaction-id" *ngIf="checkIfColumnActive('orderId', activeColumnsNames)">
    <span>{{ campaign?.order_id || ('no_data' | t) }}</span>
  </td>
  <td class="option transaction-id" *ngIf="checkIfColumnActive('additionalData', activeColumnsNames)">
    <ng-container *ngIf="campaign?.additional_data">
      <div class="d-flex flex-column">
        <span>{{ 'stats_deposit' | t }}: {{ campaign?.additional_data?.deposit || ('no_data' | t) }}</span>
        <span>{{ 'stats_ngr' | t }}: {{ campaign?.additional_data?.ngr || ('no_data' | t) }}</span>
        <span>{{ 'stats_turnover' | t }}: {{ campaign?.additional_data?.turnover || ('no_data' | t) }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="!campaign?.additional_data">
      <span>{{ ('no_data' | t) }}</span>
    </ng-container>
  </td>
  <td class="option transaction-id" *ngIf="checkIfColumnActive('cartValue', activeColumnsNames)">
    <span>{{ campaign?.cart_value?.amount_user_currency || ('no_data' | t) }}</span>
    <span *ngIf="campaign?.cart_value?.amount_original_currency !== campaign?.cart_value?.amount_user_currency">
      ({{ campaign?.cart_value?.amount_original_currency || ('no_data' | t) }})
    </span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('status', activeColumnsNames)">
    <div class="name-wrapper">
      <div class="configuration-name" *ngIf="title === 'leads'; else joinStatus" [ngClass]="leadsStatuses[campaign?.status ?? '']">
        <h4>{{ 'view_translations.' + ( campaign?.status === '0' ? 'toPay' : leadsStatuses[campaign?.status ?? ''] ) | translate }}</h4>
      </div>
    </div>
    <ng-template #joinStatus>
      <div class="configuration-name" [ngClass]="campaign?.status ?? ''">
        <h4>{{ 'view_translations.' + (campaign?.status === 'active' ? 'accepted' : campaign?.status ) | translate }}</h4>
      </div>
    </ng-template>
  </td>
  <td
    class="option list lead"
    [ngClass]="{
        'lead' : !isDetailsTableLayout,
        'column' : compareMode && Object.keys(campaignToCompare).length && !isDetailsTableLayout,
        'details-layout': isDetailsTableLayout
      }"
    *ngIf="checkIfColumnActive('leads', activeColumnsNames)">
    <span [ngClass]="{'leadTitle' : isDetailsTableLayout, 'noMargin' : isDetailsTableLayout && (compareMode && Object.keys(campaignToCompare).length) }">
      {{ leadsSummary }}
      <div
        class="change-factor"
        [ngClass]="{'bigger' : ($any(leadPercentChange) ?? 0) > 0, 'smaller' : ($any(leadPercentChange) ?? 0) < 0}"
        *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length && leadPercentChange !== 0">
        <nb-icon *ngIf="leadPercentChange !== '&infin'" icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
        <span *ngIf="leadPercentChange === '&infin'; else percentageChangeRepresentation"> &infin; </span>
        <ng-template #percentageChangeRepresentation>
          <span> {{ ($any(leadPercentChange) ?? 0 ) > 0 ? '+' : ''}}{{toFixed(leadPercentChange ?? 0)}}% </span>
        </ng-template>
      </div>
    </span>
    <div class="details-container" *ngIf="isDetailsTableLayout">
      <p class="details hover toPay" *ngIf="checkIfColumnActive('leadToPay',activeColumnsNames)">
        <nb-icon icon="{{ icons[0] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.leads }}
      </p>
      <p class="details hover accepted" *ngIf="checkIfColumnActive('leadAccepted',activeColumnsNames)">
        <nb-icon icon="{{ icons[1] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.leads_status_payment_waiting }}
      </p>
      <p class="details hover pending" *ngIf="checkIfColumnActive('leadPending',activeColumnsNames)">
        <nb-icon icon="{{ icons[2] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.leads_status_wait }}
      </p>
      <p class="details hover rejected" *ngIf="checkIfColumnActive('leadRejected',activeColumnsNames)">
        <nb-icon icon="{{ icons[3] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.leads_status_rejected }}
      </p>
    </div>
    <span *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length" class="compare">
      {{ compareLeadsSummary }}
      <div class="details-container" *ngIf="isDetailsTableLayout">
        <p class="details hover toPay" *ngIf="checkIfColumnActive('leadToPay',activeColumnsNames)">
          <nb-icon icon="{{ icons[0] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.leads }}
        </p>
        <p class="details hover accepted" *ngIf="checkIfColumnActive('leadAccepted',activeColumnsNames)">
          <nb-icon icon="{{ icons[1] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.leads_status_payment_waiting }}
        </p>
        <p class="details hover pending" *ngIf="checkIfColumnActive('leadPending',activeColumnsNames)">
          <nb-icon icon="{{ icons[2] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.leads_status_wait }}
        </p>
        <p class="details hover rejected" *ngIf="checkIfColumnActive('leadRejected',activeColumnsNames)">
          <nb-icon icon="{{ icons[3] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.leads_status_rejected }}
        </p>
      </div>
    </span>
  </td>
  <td class="option list special earnings" *ngIf="checkIfColumnActive('earnings', activeColumnsNames)">
    <span [ngClass]="{'marked' : isDetailsTableLayout && !compareMode}"
      >{{ earnsToDisplay.toFixed(2) }}
      <span class="currency">{{ campaign?.currency }}</span>
      <div
        class="change-factor"
        [ngClass]="{'bigger' : ($any(earnPercentChange) ?? 0) > 0, 'smaller' : ($any(earnPercentChange) ?? 0) < 0}"
        *ngIf="compareMode && Object.keys(campaignToCompare).length && earnPercentChange !== 0 && statisticsCompareData?.length">
        <nb-icon *ngIf="earnPercentChange !== '&infin'" icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
        <span *ngIf="earnPercentChange === '&infin'; else percentageChangeRepresentation"> &infin; </span>
        <ng-template #percentageChangeRepresentation>
          <span> {{ ($any(earnPercentChange) ?? 0) > 0 ? '+' : ''}}{{toFixed(earnPercentChange ?? 0)}}% </span>
        </ng-template>
      </div>
    </span>
    <div class="details-container" *ngIf="isDetailsTableLayout">
      <p class="details hover toPay" *ngIf="checkIfColumnActive('earningsToPay',activeColumnsNames)">
        <nb-icon icon="{{ icons[0] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.earnings_status_to_payment }}
        <span class="currency">{{ campaign?.currency }}</span>
      </p>
      <p class="details hover accepted" *ngIf="checkIfColumnActive('earningsAccepted',activeColumnsNames)">
        <nb-icon icon="{{ icons[1] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.earnings_status_payment_waiting }}
        <span class="currency">{{ campaign?.currency }}</span>
      </p>
      <p class="details hover pending" *ngIf="checkIfColumnActive('earningsPending',activeColumnsNames)">
        <nb-icon icon="{{ icons[2] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.earnings_status_wait }}
        <span class="currency">{{ campaign?.currency }}</span>
      </p>
      <p class="details hover rejected" *ngIf="checkIfColumnActive('earningsRejected',activeColumnsNames)">
        <nb-icon icon="{{ icons[3] }}" pack="icomoon" class="icon"></nb-icon>
        {{ campaign?.earnings_status_rejected }}
        <span class="currency">{{ campaign?.currency }}</span>
      </p>
    </div>
    <span *ngIf="isDetailsTableLayout && (compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length)" class="compare">
      <span class="currency-wrapper">{{ compareEarnsToDisplay.toFixed(2) }}<span class="currency compare">{{ campaign?.currency }}</span></span>
      <div class="details-container" *ngIf="isDetailsTableLayout">
        <p class="details hover toPay" *ngIf="checkIfColumnActive('earningsToPay',activeColumnsNames)">
          <nb-icon icon="{{ icons[0] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.earnings_status_to_payment }}
          <span class="currency">{{ campaignToCompare.currency }}</span>
        </p>
        <p class="details hover accepted" *ngIf="checkIfColumnActive('earningsAccepted', activeColumnsNames)">
          <nb-icon icon="{{ icons[1] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.earnings_status_payment_waiting }}
          <span class="currency">{{ campaignToCompare.currency }}</span>
        </p>
        <p class="details hover pending" *ngIf="checkIfColumnActive('earningsPending', activeColumnsNames)">
          <nb-icon icon="{{ icons[2] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.earnings_status_wait }}
          <span class="currency">{{ campaignToCompare.currency }}</span>
        </p>
        <p class="details hover rejected" *ngIf="checkIfColumnActive('earningsRejected', activeColumnsNames)">
          <nb-icon icon="{{ icons[3] }}" pack="icomoon" class="icon"></nb-icon>
          {{ campaignToCompare.earnings_status_rejected }}
          <span class="currency">{{ campaignToCompare.currency }}</span>
        </p>
      </div>
    </span>

    <div class="percentage-share" *ngIf="!isDetailsTableLayout && summaryOfEarns > 0">
      <div
        *ngIf="toPayPercent > 0"
        class="toPay"
        [style.width.%]="toPayPercent"
        [ngbTooltip]="earnsToPayment"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
      <div
        *ngIf="acceptedPercent > 0"
        class="accepted"
        [style.width.%]="acceptedPercent"
        [ngbTooltip]="earnsPaymentWaiting"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
      <div
        *ngIf="pendingPercent > 0"
        class="pending"
        [style.width.%]="pendingPercent"
        [ngbTooltip]="earnsWait"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
      <div
        *ngIf="rejectedPercent > 0"
        class="rejected"
        [style.width.%]="rejectedPercent"
        [ngbTooltip]="earnsRejected"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
    </div>
    <span *ngIf="!isDetailsTableLayout &&  (compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length)" class="compare sec"
      >{{ compareEarnsToDisplay.toFixed(2) }}<span class="currency compare">{{ campaign?.currency }}</span></span
    >
    <div
      class="percentage-share"
      *ngIf="!isDetailsTableLayout && (compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length) && compareSummaryOfEarns > 0">
      <div
        *ngIf="toPayComparePercent > 0"
        class="toPay"
        [style.width.%]="toPayComparePercent"
        [ngbTooltip]="earnsToPaymentCompare"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
      <div
        *ngIf="acceptedComparePercent > 0"
        class="accepted"
        [style.width.%]="acceptedComparePercent"
        [ngbTooltip]="earnsPaymentWaitingCompare"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
      <div
        *ngIf="pendingComparePercent > 0"
        class="pending"
        [style.width.%]="pendingComparePercent"
        [ngbTooltip]="earnsWaitCompare"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
      <div
        *ngIf="rejectedComparePercent > 0"
        class="rejected"
        [style.width.%]="rejectedComparePercent"
        [ngbTooltip]="earnsRejectedCompare"
        container="body"
        placement="top"
        tooltipClass="my-configurations-tooltip"></div>
    </div>
  </td>

  <td
    class="option special"
    [ngClass]="{'column' : compareMode && Object.keys(campaignToCompare).length}"
    *ngIf="checkIfColumnActive('uniqueVisits', activeColumnsNames)">
    <span
      >{{ campaign?.visits }}
      <div
        class="change-factor"
        [ngClass]="{'bigger' : ($any(visitsPercentChange) ?? 0 )> 0, 'smaller' : ($any(visitsPercentChange) ?? 0) < 0}"
        *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length && visitsPercentChange !== 0">
        <nb-icon *ngIf="visitsPercentChange !== '&infin'" icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
        <span *ngIf="visitsPercentChange === '&infin'; else percentageChangeRepresentation"> &infin; </span>
        <ng-template #percentageChangeRepresentation>
          <span>{{ ($any(visitsPercentChange) ?? 0) > 0 ? '+' : ''}}{{toFixed(visitsPercentChange ?? 0)}}%</span>
        </ng-template>
      </div>
    </span>
    <span *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length" class="compare">{{ campaignToCompare.visits }}</span>
  </td>
  <td
    class="option"
    [ngClass]="{'column' : compareMode && Object.keys(campaignToCompare).length}"
    *ngIf="checkIfColumnActive('conversion', activeColumnsNames)">
    <span
      >{{ campaign?.conversion }}%
      <div
        class="change-factor"
        [ngClass]="{'bigger' : ($any(conversionPercentChange) ?? 0) > 0, 'smaller' : ($any(conversionPercentChange) ?? 0) < 0}"
        *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length && conversionPercentChange !== 0">
        <nb-icon *ngIf="conversionPercentChange !== '&infin'" icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
        <span *ngIf="conversionPercentChange === '&infin'; else percentageChangeRepresentation"> &infin; </span>
        <ng-template #percentageChangeRepresentation>
          <span>{{ ($any(conversionPercentChange) ?? 0) > 0 ? '+' : ''}}{{toFixed(conversionPercentChange ?? 0)}}%</span>
        </ng-template>
      </div>
    </span>
    <span *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length" class="compare"
      >{{ campaignToCompare.conversion }}%</span
    >
  </td>
  <td
    class="option special acceptance"
    [ngClass]="{'column' : compareMode && Object.keys(campaignToCompare).length}"
    *ngIf="checkIfColumnActive('acceptance', activeColumnsNames)">
    <span
      >{{ campaign?.acceptance }}%
      <div
        class="change-factor"
        [ngClass]="{'bigger' : ($any(acceptancePercentChange) ?? 0) > 0, 'smaller' : ($any(acceptancePercentChange) ?? 0) < 0}"
        *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length && acceptancePercentChange !== 0">
        <nb-icon *ngIf="acceptancePercentChange !== '&infin'" icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
        <span *ngIf="acceptancePercentChange === '&infin'; else percentageChangeRepresentation"> &infin; </span>
        <ng-template #percentageChangeRepresentation>
          <span>{{ ($any(acceptancePercentChange) ?? 0) > 0 ? '+' : ''}}{{toFixed(acceptancePercentChange ?? 0)}}%</span>
        </ng-template>
      </div>
    </span>
    <span *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length" class="compare"
      >{{ campaignToCompare.acceptance }}%</span
    >
  </td>
  <td class="option" [ngClass]="{'column' : compareMode && Object.keys(campaignToCompare).length}" *ngIf="checkIfColumnActive('epc', activeColumnsNames)">
    <span
      >{{ campaign?.epc }} <span class="currency">{{ campaign?.currency }}</span>
      <div
        class="change-factor"
        [ngClass]="{'bigger' : ($any(epcPercentChange) ?? 0) > 0, 'smaller' : ($any(epcPercentChange) ?? 0) < 0}"
        *ngIf="compareMode && statisticsCompareData?.length && Object.keys(campaignToCompare).length && epcPercentChange !== 0">
        <nb-icon *ngIf="epcPercentChange !== '&infin'" icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
        <span *ngIf="epcPercentChange === '&infin'; else percentageChangeRepresentation"> &infin; </span>
        <ng-template #percentageChangeRepresentation>
          <span>{{ ($any(epcPercentChange) ?? 0) > 0 ? '+' : ''}}{{toFixed(epcPercentChange ?? 0)}}%</span>
        </ng-template>
      </div>
    </span>
    <span *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length" class="compare"
      >{{ campaignToCompare.epc }}<span class="currency">{{ campaign?.currency }}</span></span
    >
  </td>
  <td class="option" [ngClass]="{'column' : compareMode && Object.keys(campaignToCompare).length}" *ngIf="checkIfColumnActive('rate', activeColumnsNames)">
    <span> {{ campaign?.rate || campaign?.amount }} </span>
    <!-- <span *ngIf="compareMode && Object.keys(campaignToCompare).length" class="compare">
        {{ Object.keys(campaignToCompare).length.rate || Object.keys(campaignToCompare).length.amount }}
      </span> -->
  </td>
  <td class="option" *ngIf="checkIfColumnActive('countries', activeColumnsNames) && campaign?.countries">
    <div class="flags-list">
      <div class="flag-icon" *ngFor="let country of campaign?.countries?.slice(0,maxFlags)">
        <div
          class="tooltip-button tool-tip"
          ngbTooltip="{{ ('countries.' + (country.id - 1) | translate).name }}"
          container="body"
          placement="top-right"
          tooltipClass="my-configurations-tooltip">
          <img class="flag-icon" src="{{ 'assets/icons/flags/' + country.code.toLowerCase() + '.png' }}" alt="{{ country }}" />
        </div>
      </div>
      <div
        *ngIf="(campaign?.countries?.length ?? 0) > 3"
        class="show-more-countries global-transition"
        (click)="open('', 'view_translations.countries', 'countries')">
        + {{ (campaign?.countries?.length ?? 0) - maxFlags }}
      </div>
    </div>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('countries', activeColumnsNames) && campaign?.country">
    <div class="flag-icon">
      <div
        class="tooltip-button tool-tip"
        ngbTooltip="{{ ( 'countries.' + (campaign?.country?.id - 1 ) | translate).name }}"
        container="body"
        placement="top-right"
        tooltipClass="my-configurations-tooltip">
        <img class="flag-icon" src="{{ 'assets/icons/flags/' + campaign?.country.code.toLowerCase() + '.png' }}" alt="{{ campaign?.country }}" />
      </div>
    </div>
  </td>
  <td class="option referrer" *ngIf="checkIfColumnActive('refferingAddress', activeColumnsNames)">
    <span>{{ campaign?.referrer }}</span>
  </td>
  <td class="option ml-sub" *ngIf="checkIfColumnActive('mlSub', activeColumnsNames)">
    <ng-container *ngIf="showMlSubs; else mlSubsEmpty">
      <ng-container *ngFor="let sub of Object.values(campaign?.user_transaction_parameters ?? {}); index as i">
        <span *ngIf="sub" ngbTooltip="{{ sub }}" container="body" placement="top" tooltipClass="my-configurations-tooltip"
          >{{ ('ml_sub' + (i + 1) )}}: {{sub ? sub : ('no_data' | t)}}</span
        >
      </ng-container>
    </ng-container>
    <ng-template #mlSubsEmpty>
      <span>{{'no_data' | t}}</span>
    </ng-template>
  </td>

  <td class="option transaction-id" *ngIf="checkIfColumnActive('transactionId', activeColumnsNames)">
    <span>{{ campaign?.transaction_id }}</span>
  </td>

  <td class="option" *ngIf="checkIfColumnActive('created', activeColumnsNames)">
    <span *ngIf="campaign?.created_at">{{ campaign?.created_at | date : 'dd.MM.yyyy, H:mm' | changeDateFormat:'at':'normal'}}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('updated', activeColumnsNames)">
    <span *ngIf="campaign?.updated_at">{{ campaign?.updated_at | date : 'dd.MM.yyyy, H:mm' | changeDateFormat:'at':'normal'}}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('browser', activeColumnsNames)">
    <span>{{ parsedUserAgent?.browser.name || campaign?.user_agent_details?.browser || campaign?.user_agent?.browser}}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('browserVersion', activeColumnsNames)">
    <span>{{ parsedUserAgent?.browser.version || campaign?.user_agent_details?.browser_version || campaign?.user_agent?.browser_version}}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('operatingSystem', activeColumnsNames)">
    <span>{{ parsedUserAgent?.os.name || campaign?.user_agent_details?.operation_system || campaign?.user_agent?.operation_system}}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('operatingSystemVersion', activeColumnsNames)">
    <span>{{ parsedUserAgent?.os.version || campaign?.user_agent_details?.operation_system_version || campaign?.user_agent?.operation_system_version }}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('device',activeColumnsNames)">
    <span>
      {{ parsedUserAgent?.device.model || campaign?.user_agent_details?.brand || campaign?.user_agent?.brand }} {{ parsedUserAgent?.device.model ||
      campaign?.user_agent_details?.brand_model || campaign?.user_agent?.brand_model}}
    </span>
  </td>
  <ng-container *ngIf="checkIfColumnActive('sources', activeColumnsNames)">
    <td class="option">
      <div *ngFor="let source of Object.values(campaign?.traffic_sources ?? {})" class="link">{{ source }}</div>
    </td>
  </ng-container>
  <td class="option" *ngIf="checkIfColumnActive('categories', activeColumnsNames)">
    <span *ngFor="let category of categoriesToDisplay | slice:0:maxShownCategories; index as i">
      {{ 'categories.' + category | translate }}
      <span [ngClass]="{'d-none': i === categoriesToDisplay.length - 1 || (i === 1 && maxShownCategories === 2)}">,</span>
    </span>
    <button *ngIf="categoriesToDisplay.length > 2" class="btn expand-collapse-button" (click)="expandOrCollapseCategories()">
      {{ 'view_translations.' + ( maxShownCategories === 2 ? 'expand' : 'collapse' ) | translate }}
    </button>
  </td>
  <!-- <div class="option" [ngClass]="{'column' : compareMode && Object.keys(campaignToCompare).length}" *ngIf="salesValue">
      <span
        >{{ campaign.amount }} <span class="currency">{{ campaign.currency }}</span>
        <div
          class="change-factor"
          [ngClass]="{'bigger' : salesPercentChange > 0, 'smaller' : salesPercentChange < 0, '' : salesPercentChange == 0}"
          *ngIf="compareMode && Object.keys(campaignToCompare).length">
          <nb-icon *ngIf="salesPercentChange !== '&infin'" icon="arrow-up" pack="icomoon" class="icon-up"></nb-icon>
          <span> <span *ngIf="salesPercentChange > 0">+</span>{{toFixed(salesPercentChange, 1)}}%</span>
        </div>
      </span>
      <span *ngIf="compareMode && Object.keys(campaignToCompare).length && statisticsCompareData?.length" class="compare"
        >{{ campaignToCompare.sales_value }}<span class="currency">{{ campaign.currency }}</span></span
      >
    </div> -->
  <td class="option" *ngIf="checkIfColumnActive('placeOfPromotion', activeColumnsNames)">
    <span>{{ campaign?.promotion_place }}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('registrationDate', activeColumnsNames)">
    <span>{{ campaign?.registration_date | date:'dd.MM.YYYY, H:mm' }}</span>
  </td>
  <td class="option" *ngIf="checkIfColumnActive('safePage', activeColumnsNames)">
    <span>{{ campaign?.safe_page }}</span>
  </td>
</ng-container>

<!-- Templates for earnings bars -->

<ng-template #earnsToPayment>
  <div class="big-tooltip">
    <p>{{ 'view_translations.withdrawal_commissions' | translate }}</p>
    <p>{{ earningsStatusToPayment + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>

<ng-template #earnsPaymentWaiting>
  <div class="big-tooltip">
    <p>{{ 'view_translations.accepted_commissions' | translate }}</p>
    <p>{{ earningsStatusPaymentWaiting + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>

<ng-template #earnsWait>
  <div class="big-tooltip">
    <p>{{ 'view_translations.pending_commissions' | translate }}</p>
    <p>{{ earningsStatusWait + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>

<ng-template #earnsRejected>
  <div class="big-tooltip">
    <p>{{ 'view_translations.rejected_commissions' | translate }}</p>
    <p>{{ earningsStatusRejected + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>

<ng-template #earnsToPaymentCompare>
  <div class="big-tooltip">
    <p>{{ 'view_translations.withdrawal_commissions' | translate }}</p>
    <p>{{ earningsStatusToPaymentCompare + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>

<ng-template #earnsPaymentWaitingCompare>
  <div class="big-tooltip">
    <p>{{ 'view_translations.accepted_commissions' | translate }}</p>
    <p>{{ earningsStatusPaymentWaitingCompare + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>

<ng-template #earnsWaitCompare>
  <div class="big-tooltip">
    <p>{{ 'view_translations.pending_commissions' | translate }}</p>
    <p>{{ earningsStatusWaitCompare + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>

<ng-template #earnsRejectedCompare>
  <div class="big-tooltip">
    <p>{{ 'view_translations.rejected_commissions' | translate }}</p>
    <p>{{ earningsStatusRejectedCompare + ' ' + campaign?.currency }}</p>
  </div>
</ng-template>
